(function() {
    window.OrderEntry = function() {
        $('select').each(function(i, el) {
            initSelectize(el);
            el.selectize.on('change', onBasicInfoChange);
            el.selectize.on('load', onBasicInfoLoad);
        });
        addEventListeners();

        $previewModal = $('#preview-modal');
        $previewModal[0].preview = new LensePreview($previewModal);
        $('.collapse').collapse();
    };

    // http://stackoverflow.com/a/29627286/2424975
    var gup = function(param) {
        var found;
        window.location.search.substr(1).split("&").forEach(function(item) {
            if (param ==  item.split("=")[0]) {
                found = item.split("=")[1];
            }
        });
        return found;
    };

    OrderEntry.LANG = window.location.pathname.split('/')[1];
    OrderEntry.TYPE = gup('stype');

    var onBasicInfoChange = function(e) {
        resetSelectizeAfterBasicSelect.bind(this)();
        loadNextSelect.bind(this)();
    };

    var onBasicInfoLoad = function(e) {
        focusSelectize.bind(this)();
    };

    var onStylesChange = function() {
        $('#eye-info-outer-panel').collapse('hide');
        $('#job-info-outer-panel').collapse('hide');
        $('.field').empty();
    };

    var addEventListeners = function() {
        $('#patient-info input').each(function(i, el) {
            $(el).on('keydown', onPatientInfoKeyDown);
        });
        $('#styles')[0].selectize.on('change', onStylesChange);
        $('.panel-collapse').on('show.bs.collapse', pointChevronDown).on('hide.bs.collapse', pointChevronRight);
        $(document).on('keydown', function(e) {
            if(e.which === 13) {
                e.stopPropagation();
            }
        });
        $('#addresses').on('keypress', function(e) {
            restrictLinesOfInput(this.value, e, 5);
        });
        $('#comments').on('keypress', function(e) {
            restrictLinesOfInput(this.value, e, 10);
        });
        $('#submit-button').on('click', onSubmitClick);
    };

    var count = function(s, c) {
        return s.split(c).length - 1;
    };

    var restrictLinesOfInput = function(str, e, maxLines) {
        if (count(str, '\n') >= (maxLines - 1) && e.which == 13) {
            e.preventDefault();
        }
    };

    var restrictCharacters = function(str, e, numChars) {
        if (str.length >= numChars && e.which != 8) {
            e.preventDefault();
        }
    };

    var pointChevron = function(dir, e) {
        e.stopPropagation();
        var $span = $(e.target.parentNode).find('span');
        $span.eq(0).attr('class', $span.eq(0).attr('class').replace(/right|down/, dir));
    };

    var pointChevronRight = function(e) {
        pointChevron('right', e);
    };

    var pointChevronDown = function(e) {
        pointChevron('down', e);
    };

    var addBasicInfoToSubmit = function(msg) {
        var options = $('#fullstyles').val().split(',');
        var style = $('#styles').val();
        msg.append('rightstyle', style);
        msg.append('leftstyle', style);
        msg.append('rightmaterial', options[0]);
        msg.append('leftmaterial', options[0]);
        msg.append('rightcolor', options[1]);
        msg.append('leftcolor', options[1]);
        msg.append('righttreatment', options[2]);
        msg.append('lefttreatment', options[2]);
        $('#addons')[0].selectize.getValue().forEach(function(el) {
            msg.append('addons[]', el);
        });
    };

    var addCustomerInfoToSubmit = function(msg) {
        const $patientName = $('#patientname');
        if($patientName.length) {
            msg.append('patientname', $patientName.val());
        } else {
            msg.append('patientname', `${$('#patientfirstname').val()} ${$('#patientlastname').val()}`)
        }

        msg.append('wanteddate', $('#wanteddate').val());
        msg.append('orderdate', $('#orderdate').val());
        msg.append('ponumber', $('#PONumber').val());

        var addresses = $('#addresses').val().split('\n');
        addresses.forEach(function(el) {
            msg.append('shipaddress[]', el );
        });

        msg.append('shippostalcode', $('#shippostalcode').val());
        msg.append('callfirst', $('#hold-before-processing').prop('checked') ? '1' : '0')
    };

    var addEyeInfoToSubmit = function(msg) {
        $('#eye-info-outer-panel select, #job-info-outer-panel select, #job-info-outer-panel input').each(function(i, el) {
            if (el.name && !el.disabled) {
                msg.append(el.id, el.value || " ");
            }
        });
    };

    var splitArrayIntoParts = function(array, len) {
        var res = [];
        [].forEach.call(array, function(a, i) {
            if(i % len === 0) res.push([]);
            res[res.length - 1].push(a);
        });
        return res.map(function(a) { return a.join('') });
    }

    var stringContains = function(string, search) {
        return string.split(search).length > 1;
    };

    var addCommentsToSubmit = function(msg) {
        var comments = $('#comments').val().split("\n").map(function(a) {
            return splitArrayIntoParts(a, 35);
        });
        [].concat.apply([], comments).forEach(function(el) {
            msg.append('comments[]', el);
        });
    };

    var addPresentInfoToSubmit = function(msg) {
        var checkboxes = $("input[value='right-checkbox'], input[value='left-checkbox']");
        var leftChecked = checkboxes[1].checked;
        var rightChecked = checkboxes[0].checked;

        msg.append('leftpresent', leftChecked ? '1' : '0');
        msg.append('rightpresent', rightChecked ? '1' : '0');
    };

    var addJobTypeToSubmit = function(msg) {
        msg.append('jobtype', $('#edged')[0] && !$('#edged')[0].checked ? 'U' : OrderEntry.TYPE);
    };

    var addTraceFileToSubmit = function(msg) {
        msg.append('file', $('#upload-button')[0].files[0]);
    };

    var onSubmitClick = function() {
        //$('#submit-button').unbind('click');
        $('#dimmer').fadeIn();
        var message = new FormData();
        addCustomerInfoToSubmit(message);
        addBasicInfoToSubmit(message);
        addJobTypeToSubmit(message);
        if ($('#eye-info-outer-panel select').length) {
            addEyeInfoToSubmit(message);
            addCommentsToSubmit(message);
            addPresentInfoToSubmit(message);
            if($('#upload-button').length) {
                addTraceFileToSubmit(message);
            }
        }
        message.append('lang', OrderEntry.LANG);
        message.append('stype', OrderEntry.TYPE);
        $.ajax({
            url: '/webservice/validate/',
            type: 'post',
            data: message,
            processData: false,
            contentType: false,
            timeout: 5 * 60 * 1000,
            success: onSubmitComplete,
            error: onSubmitError
        });
        //$.postJSON('/webservice/validate', { values:  JSON.stringify(message), lang: OrderEntry.LANG, stype: OrderEntry.TYPE }, onSubmitComplete);
    };

    var onPatientInfoKeyDown = function(e) {
        if (e.which === 13) {
            var $inputs = ('input, textarea');
            var index = $inputs.index(this);
            var $nextInput = $inputs.eq(index + 1);
            $nextInput.focus();
            if ($nextInput[0].tagName == "TEXTAREA") {
                e.preventDefault();
            }
        }
    };

    var scrollToTop = function() {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
    };

    var onSubmitError = function(x, t, m) {
        window.location.href = '/' + OrderEntry.LANG + '/login'
    };

    var onSubmitComplete = function(response) {
        console.log("Submit Complete");
        $('#alert-container').empty();
        if (Util.isNumeric(response[0])) {
            $('#real-order-id').val(response[0]);
            $('#order-entry-form').submit();
        } else {
            $('#dimmer').fadeOut();
            displayErrors(response);
            scrollToTop();
            //$('#submit-button').on('click', onSubmitClick);
        }
    };

    var displayErrors = function(errors) {
        var $container = $('#alert-container');
        errors.forEach(function(error) {
            $container.append($('<div/>', {
                class: 'flash error',
                text: error
            }));
        });
    };

    var resetSelectizeAfterBasicSelect = function() {
        if (this.getValue().length <= 0) return;
        var $selects = $('#basic-info select');
        var index = $selects.index(this.$input);
        $selects.slice(index + 1).each(function(i, el) {
            el.selectize.clearOptions();
            el.selectize.disable();
        });
    };

    var initSelectize = function(el) {
        var opts = {
            dropdownParent: 'body',
            labelField: 'desc',
            valueField: 'code',
            searchField: 'desc',
            selectOnTab: true,
            sortField: 'desc',
            onType: onType,
            openOnFocus: true,
            score: Util.calcScore,
            onDropdownClose: onDropdownClose
        };
        $(el).selectize(opts);
    };

    var webserviceCall = function(url, data, callback) {
        data.ordertype = OrderEntry.TYPE;
        data.lang = OrderEntry.LANG;
        return $.getJSON('/webservice/' + url, data, callback);
    };

    var onType = function() {
        if (this.hasOptions) {
            this.$control.removeClass('focus-warning');
        } else {
            this.$control.addClass('focus-warning');
        }
    };

    var isEmpty = function(s) {
        return !s || !s.length;
    };

    var onDropdownClose = function() {
        var isEyeField = stringContains(this.$input[0].id, /right|left/);
        if (this.currentResults.items[0]) {
            this.$control.removeClass('focus-warning');
            if (isEyeField && !isEmpty(this.lastQuery)) {
                this.setValue(this.currentResults.items[0].code);
            }
        }
    };

    var loadNextSelect = function() {
        if (this.getValue().length <= 0) return;
        if (this.$input.is($('#styles'))) {
            var fieldCall = webserviceCall('fields', {
                style: this.$input[0].selectize.getValue()
            });
        }

        var selectize = this.$input[0].selectize;
        var index = $('#basic-info select').index(this.$input);
        var nextControl = $('#basic-info select')[index + 1];
        if (nextControl) {
            nextControl.selectize.load(function(callback) {
                var call = webserviceCall(nextControl.id, {
                    type: $('#types').val(),
                    style: $('#styles').val(),
                    material: $('#materials').val(),
                    treatment: $('#treatments').val()
                });
                $.when(call, fieldCall).then(function(options, fields) {
                    if (fields) {
                        createEyeFields(fields[0].pereyefields, fields[0].right, fields[0].left);
                        if(fields[0].perjobfields.length > 0 && fields[0].perjobfields[0].level) {
                            createEyeFields(fields[0].perjobfields);
                        }
                        addFieldEventListeners();
                        disableInteractiveFields();
                        if(OrderEntry.TYPE != 'u') {
                            initLensePreview();
                        }

                    }
                    if (fieldCall) {
                        options[0].forEach(function(a) {
                            a.code = (a.matcode || '') + ','+ (a.tintcode || '') + ',' + (a.treatcode || '');
                        });
                    }
                    $(nextControl).focus();
                    console.log(options[0]);
                    callback(options[0]);
                }).fail(function() {
                    selectize.clear();
                    nextControl.selectize.$wrapper.removeClass("loading");
                    window.alert("Error getting data from server. Please try again.");
                });
            });
        }
    };

    var initLensePreview = function() {
        $('#preview-modal')[0].preview.makeSliders();
    };

    var onPrismAxisChange = function() {
        var $prisms;
        if (stringContains(this.$input[0].id, 'right')) {
            $prisms = $('#right-prism select');
        } else {
            $prisms = $('#left-prism select');
        }

        if (Util.isNumeric(this.getValue()) || this.items.length <= 0) {
            $prisms.slice(2).each(function(i, el) {
                el.selectize.disable();
                el.selectize.clear();
                $(el).removeClass('focus-warning');
            });
        } else {
            $prisms[3].selectize.clear();
            $prisms[3].selectize.enable();
            $prisms[2].selectize.enable();

            /*
             Selectize won't run the search function if the query doesn't change,
             resulting in incorrect prism axis combinations. This only happens when
             selecting the input with your mouse.
              */
            $prisms[3].selectize.lastQuery = null;

        }
    };

    var onPrism1Change = function() {
        var info = stringContains(this.$input[0].id, 'right') ? '#right' : '#left';
        if (['0.00', '', null].indexOf(this.getValue()) >= 0) {
            $(info + 'prismaxis1')[0].selectize.clear();
            $(info + 'prismaxis1')[0].selectize.disable();
            $(info + 'prism2')[0].selectize.clear();
            $(info + 'prism2')[0].selectize.disable();
            $(info + 'prism2').removeClass("focus-warning");
            $(info + 'prismaxis2').removeClass("focus-warning");
            $(info + 'prismaxis2')[0].selectize.clear();
            $(info + 'prismaxis2')[0].selectize.disable();
        } else {
            $(info + 'prismaxis1')[0].selectize.enable();
        }
    };

    var onPrism2Change = function() {
        var side = stringContains(this.$input[0].id, 'right') ? '#right' : '#left';
        var $axis = $(side + 'prismaxis2');
        if (['0.00', '', null].indexOf(this.getValue()) >= 0) {
            $axis[0].selectize.clear();
            $axis[0].selectize.disable();
            $axis.removeClass('focus-warning');
        } else {
            $axis[0].selectize.enable();
        }
    };

    var disableInteractiveFields = function() {
        var rightAxis = $('#rightaxis')[0];
        var leftAxis = $('#leftaxis')[0];
        if (rightAxis) {
            rightAxis.selectize.disable();
        }
        if (leftAxis) {
            leftAxis.selectize.disable();
        }
        $('#right-prism select').slice(1).each(function(i, el) {
            el.selectize.disable();
        });
        $('#left-prism select').slice(1).each(function(i, el) {
            el.selectize.disable();
        });
    };

    var somethingFocused = function() {
        return $(':focus').length > 0;
    };

    var focusSelectize = function() {
        var self = this;
        var $basicInfo = $('#basic-info select');
        var index = $basicInfo.index(this.$input);
        var prev = $basicInfo[index - 1];
        if (!prev) return;
        setTimeout(function() {
            self.enable();
            if(prev.selectize.isFocused || !somethingFocused) {
                self.focus();
            }
        }, 0);
    };

    var onCylinderChange = function() {
        var $axis = stringContains(this.$input[0].id, 'right') ? $('#rightaxis') : $('#leftaxis');
        if (!$axis) return;
        if (['0.00', ''].indexOf(this.getValue()) >= 0) {
            $axis[0].selectize.disable();
            $axis[0].selectize.clear();
            $axis[0].selectize.$control.removeClass('focus-warning');
        } else {
            $axis[0].selectize.enable();
        }
    };

    var prismSearch = function(side) {
        var prismAxis1 = $('#' + side + 'prismaxis1')[0].selectize;
        return function(search) {

            var prismAxis1Value = prismAxis1.items[0];
            //console.log(prismAxis1Value);
            return function(item) {
                console.log(prismAxis1Value);
                switch (prismAxis1Value) {
                    case "Down":
                    case "Up":
                        if (item.code == "Up" || item.code == "Down") return 0;
                        break;
                    case "In":
                    case "Out":
                        if (item.code == "In" || item.code == "Out") return 0;
                        break;
                }
                return Util.startsWith(item.desc.toLowerCase(), search.toLowerCase());
            }
        }
    };

    var addFieldEventListeners = function() {
        $('#rightcylinder')[0].selectize.on('change', onCylinderChange);
        $('#leftcylinder')[0].selectize.on('change', onCylinderChange);
        $('#rightprism1')[0].selectize.on('change', onPrism1Change);
        $('#leftprism1')[0].selectize.on('change', onPrism1Change);
        $('#rightprism2')[0].selectize.on('change', onPrism2Change);
        $('#leftprism2')[0].selectize.on('change', onPrism2Change);
        $('#rightprismaxis1')[0].selectize.on('change', onPrismAxisChange);
        $('#leftprismaxis1')[0].selectize.on('change', onPrismAxisChange);
        $('#upload-button').on('change', onTraceFileSelect);

        $('#rightprismaxis2')[0].selectize.settings.score = prismSearch('right');
        $('#leftprismaxis2')[0].selectize.settings.score = prismSearch('left');
    };

    var disableTraceFields = function() {
        $('#framea')[0].selectize.disable();
        $('#frameb')[0].selectize.disable();
        $('#framedbl')[0].selectize.disable();
        $('#frameed')[0].selectize.disable();
        $('#framecircum')[0].selectize.disable();
        $('#edgetype')[0].selectize.disable();
    };

    var enableTraceFields = function() {
        $('#framea')[0].selectize.enable();
        $('#frameb')[0].selectize.enable();
        $('#framedbl')[0].selectize.enable();
        $('#frameed')[0].selectize.enable();
        $('#framecircum')[0].selectize.enable();
        $('#edgetype')[0].selectize.enable();
    };

    var removeLoadersFromTraceFields = function() {
        $('#framea')[0].selectize.$wrapper.removeClass('loading');
        $('#frameb')[0].selectize.$wrapper.removeClass('loading');
        $('#framedbl')[0].selectize.$wrapper.removeClass('loading');
        $('#frameed')[0].selectize.$wrapper.removeClass('loading');
        $('#edgetype')[0].selectize.$wrapper.removeClass('loading');
        $('#framecircum')[0].selectize.$wrapper.removeClass('loading');
    };

    var addLoadersToTraceFields = function() {
        $('#framea')[0].selectize.$wrapper.addClass('loading');
        $('#frameb')[0].selectize.$wrapper.addClass('loading');
        $('#framedbl')[0].selectize.$wrapper.addClass('loading');
        $('#frameed')[0].selectize.$wrapper.addClass('loading');
        $('#framecircum')[0].selectize.$wrapper.addClass('loading');
        $('#edgetype')[0].selectize.$wrapper.addClass('loading');
    };

    var onTraceFileSelect = function(e) {
        var formData = new FormData();
        var self = this;
        $('#preview-modal')[0].preview.clear();
        formData.append('file', this.files[0]);
        $('#traceid')[0].selectize.clear();
        disableTraceFields();
        addLoadersToTraceFields();
        $.ajax({
            url: '/webservice/parse-trace',
            type: 'post',
            data: formData,
            processData: false,
            contentType: false,
            success: function(data) {
                console.log(data);

                $('#preview-modal')[0].preview.updateVertices(data.data);
                $('#preview-modal')[0].preview.setValuesFromData();
                $('#preview-modal')[0].preview.setDBL(data.dbl || 0);
                $('#preview-modal')[0].preview.fillSelectize();
                if(!data.dbl) {
                    $('#framedbl')[0].selectize.clear();
                }

                $('#preview-button').prop('disabled', false);

                enableTraceFields();
                removeLoadersFromTraceFields();
            },
            error: function() {
                console.log("ERROR");
                $('#framea')[0].selectize.clear();
                $('#frameb')[0].selectize.clear();
                $('#framedbl')[0].selectize.clear();
                $('#frameed')[0].selectize.clear();
                $('#edgetype')[0].selectize.clear();
                $('#framecircum')[0].selectize.clear();
                self.value = "";
                enableTraceFields();
                removeLoadersFromTraceFields();
            }
        });
    };

    var createEyeFields = function(data, right, left) {
        if (OrderEntry.TYPE == "F") {
            $('#job-info-outer-panel').collapse('show');
        }
        var $divs = $('.field-parent');
        var fields =  [ [], [], [], [], [], [], [], [], [] ];
        data.forEach(function(el) {
            fields[el.level - 1].push(el);
        });
        fields.forEach(function(el, i) {
            if (fields[i].length > 0)  {
                $divs.eq(i).parent().collapse(i % 2  === 0 ? 'show' : 'hide');
                var $rightDiv = $divs.eq(i).children().eq(0);
                var $leftDiv = $divs.eq(i).children().eq(1);
                var fb = new FormBuilder();
                if ($leftDiv.length) {
                    $rightDiv.empty();
                    $leftDiv.empty();
                    var $rightEyeField = fb.createFieldRow(fields[i], 'right', right);
                    var $leftEyeField = fb.createFieldRow(fields[i], 'left', left);
                    $rightDiv.append($rightEyeField);
                    $leftDiv.append($leftEyeField);
                } else {
                    var $fieldRow = fb.createFieldRow(fields[i]);
                    if (i == 7 || i == 6) {
                        $divs.eq(6).children().eq(0).empty().append($fieldRow);
                    } else if(i > 7) {
                        $divs.eq(7).children().eq(0).empty().append($fieldRow);
                    }
                }
            }
        });

        $('#eye-info-outer-panel').collapse('show');
        $divs.each(function(i, el) {
            if (el.children[0].children.length <= 0) {
                $(el.parentNode.parentNode).hide();
            } else {
                $(el.parentNode.parentNode).show();
            }
        });
    };

})();

$.extend({
    postJSON: function(url, data, func) {
        $.post(url, data, func, 'json').fail(function(e) {
            console.error('Failed', e.status, e.statusText);
        });
    }
});

$(function() {
    new Pikaday({
        field: document.getElementById('wanteddate'),
        minDate: new Date(),
        format: 'YYYY/MM/DD'
    });

    new OrderEntry();
});
